import React, { Component } from 'react'
import { createStyles, WithStyles, withStyles, Theme, Dialog, DialogContent, Button, Typography, CircularProgress } from '@material-ui/core'
import _ from 'lodash';
import { connect } from 'react-redux'
import { Dispatch } from 'redux';
import { TState } from '../RootReducer/index';
import SearchWithSuggestion from '../Components/SearchWithSuggestion';
import { ONewLegalFinding } from '../Features/AddNewLegalFinding/redux-config';
import THEME from '../Resources/Theme';
import { fade } from '@material-ui/core/styles/colorManipulator';
import utilities from '../Resources/Utils';
import { WithTranslationProps, withTranslations } from '../Features/Translations/withTranslations';
import { GENERAL_SUBMIT } from '../Features/Translations/translationKeys.cld';


interface IStateProps {
    open: boolean
    loading: boolean
    errorMessage: string | undefined
    documentNumber: string
}

interface IDispatchProps {
    closeDialog?: () => void
    editLegalFinding?: (id: string) => void
}


type item = {
    'Case name': string
    id: string
}

interface IState {
    formData: {
        'Case name': string
    },
    selected: string
}

interface IProps extends WithStyles<typeof STYLES>, IStateProps, IDispatchProps, WithTranslationProps { }




class NewLegalFindingDialog extends Component<IProps, IState> {
    state: IState = {
        formData: {
            'Case name': ''
        },
        selected: ''
    }

    componentDidMount() {
        this.setState({
            formData: {
                'Case name': this.props.documentNumber || ''
            }
        })
    }

    componentDidUpdate(prevProps, prevState) {

        // if (this.props.documentNumber !== prevProps.documentNumber || (this.props.documentNumber === prevProps.documentNumber && prevState.formData === this.state.formData))
        //     this.handleChange({ name: '', value: this.props.documentNumber })
        if (prevProps.loading === true && this.props.loading === false && this.props.closeDialog) {

            if (!this.props.errorMessage)
                this.props.closeDialog()
        }
    }

    handleClose = () => {
        if (this.props.closeDialog)
            this.props.closeDialog();
    }

    handleChange = ({ name, value }) => {
        this.setState({ selected: value, formData: { 'Case name': value } });
    }

    handleSuggestion = (data: any) => {
        if (_.isEmpty(_.get(data, 'facets')))
            return [];
        // const suggestions = _.map(data.results, (
        //     (item) => {
        //         let value = ((item.hit.metadata || []).find(meta => /External identifier/i.test(meta.name)) || {}).val || '';
        //         return { id: item.hit.id, 'Case name': value }
        //     }
        // ))
        return _.map(_.get(data.facets, 'externalId'), item => item.key)
    }


    handleSubmit = async () => {
        const { selected } = this.state;
        if (selected && this.props.editLegalFinding) {
            // this.handleClose();
            this.props.editLegalFinding(selected);
        }
    }

    searchFilter = (metadata_external_identifier: string) => {
        return {
            match_phrase: {
                metadata_external_identifier
            }
        }
    }

    render() {
        const { classes, open = false, loading = false, errorMessage, getTranslation } = this.props
        return (
            <Dialog
                open={open}
                disableBackdropClick
                onClose={this.handleClose}
                classes={{ container: classes.dialogContainer }}
                PaperProps={{ className: classes.root }}
            >
                <DialogHeader {...this.props} />
                <DialogContent>
                    {
                        loading ?
                            <div style={{ display: 'flex', height: '100%', alignItems: 'center', justifyContent: 'center' }}>
                                <CircularProgress />
                            </div>
                            :
                            <div style={{ paddingTop: 20 }}>
                                {errorMessage && <Typography color="error">{errorMessage}</Typography>}
                                <SearchWithSuggestion
                                    value={this.state.formData["Case name"]}
                                    suggestionUrl='/ltddocs/search'
                                    formKey='externalId'
                                    filter={this.searchFilter}
                                    label="Enter document number"
                                    handleSuggestions={this.handleSuggestion}
                                    onChange={this.handleChange}
                                />
                                <Button fullWidth className={classes.submit} onClick={this.handleSubmit}>{getTranslation(GENERAL_SUBMIT)}</Button>
                            </div>
                    }

                </DialogContent>
            </Dialog>
        )
    }
}

class DialogHeader extends Component<IProps> {

    render() {
        const { classes } = this.props
        return (
            <div className={classes.header}>
                <Typography variant="h6">New legal finding</Typography>
                <Button variant="text" onClick={e => this.props.closeDialog!()}>
                    <i className="material-icons">close</i>
                </Button>
            </div>
        )
    }
}


const mapStateToProps = (state: TState): IStateProps => ({
    open: state.NewLegalFinding.decisionSelectionDialog,
    loading: state.NewLegalFinding.loading,
    errorMessage: state.NewLegalFinding.errorMessage,
    documentNumber: _.get(state.DetailPage, 'currentDocument.document["Document Number"]')
})

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => ({
    closeDialog: () => dispatch(ONewLegalFinding.closeDecisionSelectionDialog()),
    editLegalFinding: (id: string) => dispatch(ONewLegalFinding.openNewLegalFindingDialog(true, 'home', id))
})

const STYLES = (theme: Theme) => createStyles({
    dialogContainer: {
    },
    root: {
        position: 'relative',
        width: 370,
        height: 460,
        maxWidth: 'inherit'
    },
    submit: {
        background: THEME.Colors.Third,
        '&:hover': {
            background: fade(THEME.Colors.Third, 0.8)
        },
        color: 'white',
        position: 'absolute',
        bottom: 20,
        left: 25,
        width: 318
    },
    header: {
        height: 44,
        display: 'flex',
        background: THEME.Colors.Primary.main,
        alignItems: 'center',
        paddingLeft: 15,
        justifyContent: 'space-between',
        '& h6': {
            color: THEME.Colors.Grayscale.White
        },
        '& i': {
            color: THEME.Colors.Grayscale.White
        }
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(STYLES)(withTranslations(NewLegalFindingDialog)))